<template>
  <div class="index">
    <!-- 编辑信息 -->
    <div class="editFormbox">
      <p>文章信息</p>
      <el-form label-width="120px" ref="editForm" size="mini" :model="editForm">
        <el-form-item label="文章分类：">
          <el-select v-model="catalog" placeholder="请选择">
            <el-option v-for="(x,i) in $fuwuData.overallArticle" :key="i" :label="x.text" :value="x.catalog"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章内容：">
          <editor-bar v-model="editForm.content"></editor-bar>
        </el-form-item>
        <div class="buttonbox">
          <el-button @click="rvoke()">撤销修改</el-button>
          <el-button type="primary" @click="submit()">保&emsp;存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
import EditorBar from '@/components/wangEditor'
export default {
  components: {EditorBar},
  data() {
    return {
      catalog:"knowledge",
      editForm:{
        content:""
      },
      tableData:[],//请求到的数据
      articleId:"",
    }
  },
  methods:{
    getArticle() {
      this.$api.util_search('wenzhang', {catalog:this.catalog}).then(res => {
        if (res.data.status == 0) {
          console.log(res)
          this.tableData = JSON.parse(res.data.data)
          this.editForm = this.tableData.length ? JSON.parse(JSON.stringify(this.tableData[0])) : { content: ''}
        } else { this._status(res.data) }
      })
    },
    submit() {
      let rData = {}
      rData.content = this.editForm.content
      rData.catalog = this.catalog
      if (this.tableData.length) {
        rData.id = this.editForm.id
        this.$api.util_modify('wenzhang', rData).then(res =>{
          if (res.data.status == 0) {
            this.$message.success("保存成功") 
            this.getArticle() 
          } else { this._status(res.data) }
        })
      } else {
        this.$api.util_create('wenzhang', rData).then(res =>{
          if (res.data.status == 0) {
            this.$message.success("保存成功") 
            this.getArticle() 
          } else { this._status(res.data) }
        })
      }
    },
    rvoke() {
      if (this.editForm.content != this.tableData[0].content) {
        this.$confirm('确认将修改的信息复原吗？?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.editForm = JSON.parse(JSON.stringify(this.tableData[0]));
        }).catch(() => {});
      } else {
        this.$message.info("您未修改任何信息,无需撤销")
      }
    },
  },
  watch:{
    catalog:function(val) {
      this.getArticle()
    }
  },
  created() {
    this.getArticle()
  },
}
</script>

<style lang='scss' scoped>
.editFormbox{width: 80%;margin: 20px auto;padding: 15px;border: 1px solid #ccc;border-radius: 1%;}
.editFormbox p{margin-bottom: 20px;text-align: center;font-weight: 400;color: #666;font-size: 20px;}
.el-form-item__label{font-size: 16px;}
.buttonbox{text-align: center;}
</style>